// filepath: apps/web/src/features/admin/effectsMetrics/EffectsMetricsRoute.tsx
//
// FR-UI-ADM-9 — route shell. Mounted at /operator/effects/metrics
// inside OperatorRoot (already behind OperatorTokenGate).

import React from "react";
import { EffectsMetricsPage } from "./EffectsMetricsPage";

export function EffectsMetricsRoute(): React.ReactElement {
  return <EffectsMetricsPage />;
}
